import styled from '@emotion/styled';

import { withConfig } from 'src/withConfig';



export const EventRowTitle = withConfig(theme => styled('div', { label: 'EventRowTitle' })`

    font-size: ${theme.star.eventRow.typography.fontSizePrimary};

    font-weight: ${theme.star.eventRow.typography.fontWeightPrimary};

    line-height: ${theme.star.eventRow.typography.lineHeightPrimary};

    max-width: 100%;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;

`);



export const MobileParticipant = withConfig(theme => styled('div', { label: 'MobileParticipant' })`

    color: ${theme.star.eventRow.txtColor};

    font-size: ${theme.star.eventRow.typography.fontSizePrimary};

    font-weight: ${theme.star.eventRow.typography.fontWeightPrimary};

    line-height: ${theme.star.eventRow.typography.lineHeightPrimary};

`);

